var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBellOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#333D4B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.73 21C13.5542 21.3031 13.3018 21.5547 12.9982 21.7295C12.6946 21.9044 12.3504 21.9965 12 21.9965C11.6496 21.9965 11.3054 21.9044 11.0018 21.7295C10.6981 21.5547 10.4458 21.3031 10.27 21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.63 13C18.1851 11.3714 17.973 9.68804 18 8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26 6.26001C6.08627 6.82362 5.99861 7.41023 6 8.00001C6 15 3 17 3 17H17"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 7.99999C18.0016 6.91306 17.7079 5.8461 17.1503 4.91308C16.5927 3.98007 15.7922 3.21605 14.8341 2.70263C13.8761 2.18921 12.7966 1.94569 11.7109 1.99806C10.6252 2.05043 9.57418 2.39674 8.67001 2.99999"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1L23 23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBellOff);
export default __webpack_public_path__ + "static/media/icon-bell-off.d7a4facd9f0a64792468e32370de0355.svg";
export { ForwardRef as ReactComponent };